import { useRef, useState, useCallback } from "react";
import { MoveHorizontal } from "lucide-react";

export default function BeforeAfterSlider({ before, after, title, alt }) {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);
  const dragging = useRef(false);

  const setFromClientX = useCallback((clientX) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.max(0, Math.min(100, pct)));
  }, []);

  const onPointerDown = (e) => {
    dragging.current = true;
    setFromClientX(e.clientX);
  };
  const onPointerMove = (e) => {
    if (!dragging.current) return;
    setFromClientX(e.clientX);
  };
  const onPointerUp = () => (dragging.current = false);

  return (
    <div className="group" data-testid="before-after-slider">
      <div
        ref={ref}
        className="relative aspect-[4/5] w-full select-none overflow-hidden bg-secondary touch-none cursor-ew-resize"
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerLeave={onPointerUp}
      >
        <img src={after} alt={`${alt} — after`} className="absolute inset-0 h-full w-full object-cover" draggable={false} loading="lazy" />
        <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
          <img
            src={before}
            alt={`${alt} — before`}
            className="absolute inset-0 h-full w-full max-w-none object-cover"
            style={{ width: ref.current?.offsetWidth || "100%" }}
            draggable={false}
            loading="lazy"
          />
          <span className="absolute left-3 top-3 label bg-background/70 px-2 py-1 text-foreground">Before</span>
        </div>
        <span className="absolute right-3 top-3 label bg-background/70 px-2 py-1 text-foreground">After</span>
        <div className="absolute top-0 bottom-0" style={{ left: `${pos}%` }}>
          <div className="absolute inset-y-0 -ml-px w-0.5 bg-cream" />
          <div className="absolute top-1/2 left-0 -translate-x-1/2 -translate-y-1/2 flex h-11 w-11 items-center justify-center rounded-full bg-cream text-ink shadow-lg">
            <MoveHorizontal className="h-5 w-5" strokeWidth={1.5} />
          </div>
        </div>
      </div>
      {title && <p className="mt-4 font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">{title}</p>}
    </div>
  );
}
